import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

const styles = makeStyles(() => ({
  modal: {
    maxWidth: "70vw",
    "& #modalBody": {
      borderTop: `1px solid ${colors.gray200}`,
      padding: "16px 8px",
    },
  },
}));

export default styles;
